import React from 'react';
import styled from 'styled-components';

/**
 * Footer Placeholder Component
 * 
 * This component serves as a placeholder for the actual sticky footer.
 * It allows third-party scripts to detect the footer height and position
 * their banners above it by looking for the element with ID "ngd-sticky-footer".
 * 
 * The actual footer from @plans-templates/progressive-disclosure will render
 * after the pageLoad API completes, but this placeholder reserves the space
 * immediately to prevent third-party banner overlap.
 */

const PlaceholderFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 73px;
  pointer-events: none;
  visibility: hidden;
  z-index: 1;
`;

const FooterPlaceholder = () => <PlaceholderFooter id="ngd-sticky-footer" aria-hidden="true" />;

export default FooterPlaceholder;
